// Need to use .get, beucase reducer defaulState was created by using ImmutableJS
export const selectCurrentData = (state) => state.containers.appReducer.currentData;



// WEBPACK FOOTER //
// ./src/containers/App/selectors.js